import * as reducers from './ducks';
import * as headerItems from './components/headerItems';

export default { reducers, headerItems };
